export default __webpack_public_path__ + "static/media/maneuvermentalbarrier.99a66576.png";